import { formatCurrency } from '@angular/common';

/**
 * Pay rates are stored as NUMERIC(16,5) (Sparta, HR Packet, Viewpoint PREH.HrlyRate).
 * Company 47 salaried rates are annual salary / 2080, carried to 5 decimals (#35456).
 */
export const PAY_RATE_INPUT_DECIMALS = 5;

/** Angular digitsInfo: at least 2 decimals, up to 5 only when the extra digits are non-zero. */
export const PAY_RATE_DIGITS_INFO = `1.2-${PAY_RATE_INPUT_DECIMALS}`;

/** Kendo NumericTextBox `[format]` for a currency pay-rate input (blurred display follows the same rule). */
export const PAY_RATE_INPUT_CURRENCY_FORMAT = {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: PAY_RATE_INPUT_DECIMALS,
} as const;

/** Kendo NumericTextBox `[format]` for a plain-number pay-rate input. */
export const PAY_RATE_INPUT_NUMBER_FORMAT = {
  style: 'decimal',
  minimumFractionDigits: 2,
  maximumFractionDigits: PAY_RATE_INPUT_DECIMALS,
} as const;

/** `$31.25` stays `$31.25`; `$31.24567` shows all 5 decimals. Empty values return null like `| currency`. */
export function formatPayRate(
  value: number | string | null | undefined
): string | null {
  if (value === null || value === undefined || value === '') return null;
  const n = Number(value);
  if (Number.isNaN(n)) return null;
  return formatCurrency(n, 'en-US', '$', 'USD', PAY_RATE_DIGITS_INFO);
}
